<template>
  <div
    v-if="$data.$_enableCarousel"
    :id="`catItem-carousel-${_uid}`"
    class="carousel slide"
    data-ride="carousel"
    data-interval="false"
    role="group"
    :aria-label="$translate('Ceres::Template.itemImageCarousel')"
  >
    <div class="carousel-inner">
      <a
        v-for="(imageUrl, index) in imageUrls"
        :key="index"
        class="carousel-item single-hs-item"
        :class="{active: index === 0 }"
        :href="itemUrl"
      >
        <lazy-img
          :ref="{ 'itemLazyImage' : index === 0 }"
          :image-url="imageUrl.url"
          :alt="getAltText(imageUrl)"
          :width="getImageWidth(imageUrl)"
          :height="getImageHeight(imageUrl)"
          picture-class="d-block w-100 img-fluid"
        />
      </a>
    </div>
    <a
      class="carousel-control-prev"
      :href="'#catItem-carousel-' + _uid"
      role="button"
      data-slide="prev"
    >
      <span
        class="carousel-control-prev-icon"
        aria-hidden="true"
      />
      <span class="sr-only">vorheriges Bild</span>
    </a>
    <a
      class="carousel-control-next"
      :href="'#catItem-carousel-' + _uid"
      role="button"
      data-slide="next"
    >
      <span
        class="carousel-control-next-icon"
        aria-hidden="true"
      />
      <span class="sr-only">nächstes Bild</span>
    </a>
  </div>
  <a
    v-else
    :href="itemUrl"
    class="d-block"
    :aria-label="getAltText(imageUrls[0])"
  >
    <lazy-img
      ref="itemLazyImage"
      :image-url="imageOrItemImage"
      :alt="getAltText(imageUrls[0])"
      :width="getImageWidth(imageUrls[0])"
      :height="getImageHeight(imageUrls[0])"
      picture-class="img-fluid"
    />
  </a>
</template>
<script>
export default {
    name: "CatImageCarousel",
    props: {
        imageUrlsData: { type: Array },
        itemUrl: { type: String },
        text: { type: String },
        disableCarouselOnMobile: { type: Boolean },
        enableCarousel: { type: Boolean },
        template: { type: String }
    },
    data ()
    {
        return { $_enableCarousel: false }
    },
    computed: {
        imageUrls ()
        {
            return this.imageUrlsData
        },
        imageOrItemImage ()
        {
            return this.imageUrls.length ? this.imageUrls[0].url : this.itemImage
        }
    },
    mounted ()
    {
        const isMobile = window.matchMedia("(max-width: 768px)").matches
        const shouldCarouselBeEnabled = this.enableCarousel && this.imageUrls.length > 1

        this.$data.$_enableCarousel = this.disableCarouselOnMobile && isMobile ? false : shouldCarouselBeEnabled
    },
    methods: {
        getAltText (image)
        {
            return image && image.alternate ? image.alternate : this.text
        },
        getImageWidth (image)
        {
            return image && image.width ? image.width : undefined
        },
        getImageHeight (image)
        {
            return image && image.height ? image.height : undefined
        }
    }
}
</script>
